'use client';

import React from 'react';
import { Search, X, ChevronDown } from 'lucide-react';

const CATEGORIES = ['all', 'Feed', 'Vaccine', 'Medication', 'Chemicals', 'Packaging', 'PPE', 'Equipment', 'Other'];
const STORES = ['all', 'Feed Store A', 'Feed Store B', 'Cold Store', 'Pharmacy Store', 'Biosecurity Store', 'Packaging Store'];
const STATUSES = ['all', 'in-stock', 'low', 'critical', 'out-of-stock'];

interface Props {
  search: string; onSearch: (v: string) => void;
  filterCategory: string; onCategory: (v: string) => void;
  filterStore: string; onStore: (v: string) => void;
  filterStatus: string; onStatus: (v: string) => void;
}

function FilterSelect({ id, value, options, onChange, label }: { id: string; value: string; options: string[]; onChange: (v: string) => void; label: string }) {
  return (
    <div className="relative">
      <select
        id={id}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="select-field pr-7 text-sm"
        style={{ height: '36px', minWidth: '130px' }}
        aria-label={label}
      >
        {options.map((opt) => (
          <option key={`${id}-${opt}`} value={opt}>
            {opt === 'all' ? `All ${label}s` : opt.split('-').map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join(' ')}
          </option>
        ))}
      </select>
      <ChevronDown size={12} className="absolute right-2 top-1/2 -translate-y-1/2 pointer-events-none text-muted-foreground" />
    </div>
  );
}

export default function InventoryFilters({ search, onSearch, filterCategory, onCategory, filterStore, onStore, filterStatus, onStatus }: Props) {
  const hasFilters = search || filterCategory !== 'all' || filterStore !== 'all' || filterStatus !== 'all';
  return (
    <div className="flex flex-wrap items-center gap-2 p-3 rounded-lg border mb-4" style={{ backgroundColor: 'var(--card)', borderColor: 'var(--border)' }}>
      <div className="relative flex-1" style={{ minWidth: '200px', maxWidth: '280px' }}>
        <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
        <input
          type="text"
          value={search}
          onChange={(e) => onSearch(e.target.value)}
          placeholder="Search items, codes, suppliers..."
          className="input-field pl-9 text-sm"
          style={{ height: '36px' }}
        />
        {search && (
          <button onClick={() => onSearch('')} className="absolute right-2 top-1/2 -translate-y-1/2 btn-ghost p-0.5">
            <X size={12} />
          </button>
        )}
      </div>
      <div className="flex flex-wrap items-center gap-2">
        <FilterSelect id="inv-cat" value={filterCategory} options={CATEGORIES} onChange={onCategory} label="Category" />
        <FilterSelect id="inv-store" value={filterStore} options={STORES} onChange={onStore} label="Store" />
        <FilterSelect id="inv-status" value={filterStatus} options={STATUSES} onChange={onStatus} label="Status" />
      </div>
      {hasFilters && (
        <button
          onClick={() => { onSearch(''); onCategory('all'); onStore('all'); onStatus('all'); }}
          className="btn-ghost text-xs py-1.5 px-2 ml-auto"
          style={{ color: 'var(--danger)' }}
        >
          <X size={12} />
          Clear
        </button>
      )}
    </div>
  );
}